import { formatMonthLabel, shiftIsoMonth } from '../lib/dates';

export function MonthStepper({
  month,
  onChange,
  className = '',
  ariaLabel = 'Monat wechseln',
}: {
  month: string;
  onChange: (nextMonth: string) => void;
  className?: string;
  ariaLabel?: string;
}) {
  return (
    <div
      className={`mw-stepper ${className}`.trim()}
      role="group"
      aria-label={ariaLabel}
    >
      <button
        type="button"
        className="mw-stepper-step mw-stepper-outer"
        aria-label="Vorheriger Monat"
        onClick={() => onChange(shiftIsoMonth(month, -1))}
      >
        «
      </button>
      <span className="mw-stepper-label">{formatMonthLabel(month)}</span>
      <button
        type="button"
        className="mw-stepper-step mw-stepper-outer"
        aria-label="Nächster Monat"
        onClick={() => onChange(shiftIsoMonth(month, 1))}
      >
        »
      </button>
    </div>
  );
}
